import { Component, Vue } from 'nuxt-property-decorator';
import { MetaPropertyName } from 'vue-meta';

interface IPageHead {
	title: string;
	meta: MetaPropertyName[];
}

@Component({
	head(this: CmsMetaMixin) {
		return this.getPageHead();
	},
	async fetch(this: CmsMetaMixin) {
		await this.loadMeta();
	},
})
export default class CmsMetaMixin extends Vue {
	meta: any = {};
	$api: any;

	// Загрузка Meta по PATH страницы
	private async loadMeta(): Promise<void> {
		const { path } = this.$route;
		const { data: meta } = await this.$api.agent.transport(`cms/page-by-path?path=${path}`).catch(() => {
			this.$nuxt.error({ statusCode: 404 });
		});
		this.meta = meta;
	}

	getPageHead() {
		const headTitle = this.meta?.page?.title_tag || this.meta?.page?.title || this.$store?.state?.appState?.config?.siteName || ''
		const head: IPageHead = {
			title: headTitle,
			meta: [],
		};

		if (!!headTitle) {
			head.meta.push({name: 'og:title', hid: "og:title", property: "og:title", content: headTitle});
		}
		if (!!this.meta?.page?.description) {
			head.meta.push({ hid: "metadescription", name: 'description', content: this.meta?.page?.description });
			head.meta.push({name: 'og:description', hid: "og:description", property: "og:description", content: this.meta?.page?.description});
		}
		if (!!this.meta?.page?.keywords) {
			head.meta.push({ name: 'keywords', content: this.meta?.page?.keywords });
		}

		return head;
	}
}
